import React from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { gray } from '../../theme/tokens';

interface EmptyStateProps {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title = '데이터가 없습니다',
  description,
  icon = <InboxOutlined style={{ fontSize: 32, color: gray[300] }} />,
  action,
  size = 'md',
}) => {
  const padding = size === 'sm' ? '24px 0' : size === 'lg' ? '64px 0' : '40px 0';
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding, gap: 8 }}>
      {icon}
      <div style={{ fontSize: 14, fontWeight: 600, color: gray[500], marginTop: 4 }}>{title}</div>
      {description && <div style={{ fontSize: 12, color: gray[400], textAlign: 'center', maxWidth: 280 }}>{description}</div>}
      {action && <div style={{ marginTop: 12 }}>{action}</div>}
    </div>
  );
};

export default EmptyState;
